import { render, staticRenderFns } from "./ReportingStories.vue?vue&type=template&id=3189d4e6&scoped=true&"
import script from "./ReportingStories.vue?vue&type=script&lang=js&"
export * from "./ReportingStories.vue?vue&type=script&lang=js&"
import style0 from "./ReportingStories.vue?vue&type=style&index=0&id=3189d4e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189d4e6",
  null
  
)

export default component.exports